document.addEventListener("DOMContentLoaded", ()=>{
    if(window.location.href.includes('/products')){
        setTimeout(()=>{
            document.querySelector(".MAIN_CUSTOMIZE_DINNER_SET_TEMPLATE .block-offer.offer--custom.an-offer  + .form-blocks.form-blocks.no-pad.clearfix").classList.add("open_active_buy_button");
            console.log("Added!")
        }, 2000)
    }
  });